import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, signOut } from 'firebase/auth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

const googleProvider = new GoogleAuthProvider()
const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')

export async function signInWithGoogle() {
  try {
    // Try popup first, fall back to redirect if blocked
    const result = await signInWithPopup(auth, googleProvider)
    return result.user
  } catch (error) {
    if (error.code === 'auth/popup-blocked') {
      // Popup blocked, use redirect instead
      console.log('Popup blocked, using redirect...')
      await signInWithRedirect(auth, googleProvider)
      return null
    }
    console.error('Error signing in with Google:', error)
    throw error
  }
}

export async function signInWithApple() {
  try {
    // Try popup first, fall back to redirect if blocked
    const result = await signInWithPopup(auth, appleProvider)
    return result.user
  } catch (error) {
    if (error.code === 'auth/popup-blocked') {
      // Popup blocked, use redirect instead
      console.log('Popup blocked, using redirect...')
      await signInWithRedirect(auth, appleProvider)
      return null
    }
    console.error('Error signing in with Apple:', error)
    throw error
  }
}

export async function checkRedirectResult() {
  try {
    const result = await getRedirectResult(auth)
    if (result) {
      return result.user
    }
    return null
  } catch (error) {
    console.error('Error getting redirect result:', error)
    return null
  }
}

export async function logOut() {
  try {
    await signOut(auth)
  } catch (error) {
    console.error('Error signing out:', error)
    throw error
  }
}

export async function getIdToken() {
  const user = auth.currentUser
  if (!user) return null
  return user.getIdToken(true)
}
